import './group.css';import '../../../styles/sprinkles.css';import '../../../styles/components/resets.css';/* empty css                                                      */
/* empty css                                              */
/* empty css                            */
import { createRuntimeFn } from "@vanilla-extract/recipes/createRuntimeFn";
//#region src/components/layout/group/group.css.ts
var groupRecipe = createRuntimeFn({
	defaultClassName: "_10caaeja _14zs3h0 _14zs3h1",
	variantClassNames: {
		gap: {
			none: "_10caaejb _1bhunse19 _1bhunsei",
			xs: "_10caaejc _1bhunse1a _1bhunsej",
			sm: "_10caaejd _1bhunse1b _1bhunsek",
			md: "_10caaeje _1bhunse1c _1bhunsel",
			lg: "_10caaejf _1bhunse1d _1bhunsem",
			xl: "_10caaejg _1bhunse1e _1bhunsen",
			xxl: "_10caaejh _1bhunse1f _1bhunseo",
			"3xl": "_10caaeji _1bhunse1g _1bhunsep",
			"4xl": "_10caaejj _1bhunse1h _1bhunseq"
		},
		align: {
			start: "_10caaejk _10caaej0",
			center: "_10caaejl _10caaej1",
			end: "_10caaejm _10caaej2",
			stretch: "_10caaejn _10caaej3"
		},
		justify: {
			start: "_10caaejo _10caaej4",
			center: "_10caaejp _10caaej5",
			end: "_10caaejq _10caaej6",
			between: "_10caaejr _10caaej7"
		},
		wrap: {
			nowrap: "_10caaejs _10caaej8",
			wrap: "_10caaejt _10caaej9"
		}
	},
	defaultVariants: {
		gap: "md",
		align: "center",
		justify: "start",
		wrap: "nowrap"
	},
	compoundVariants: []
});
//#endregion
export { groupRecipe };
